<template functional>
  <div
    class="placeholder placeholder_overview-table-cell"
    :style="{ width: `${props.width}px`, height: `${props.height}px` }"
  />
</template>

<script>
export default {
  name: 'PlaceholderCell',
  props: {
    height: {
      type: Number,
      required: false,
      default: 10,
    },
    width: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.placeholder_overview-table-cell {
  background-image: url(~img/placeholder-background.gif);
  background-repeat: repeat-y;
  background-size: 100% 1px;
  border-radius: 2px;
  overflow: hidden;
}
</style>
